/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rte_Remove_LinkInputs */



/**
* | output |
* | --- |
* | "Remove link" |
*
* @param {Rte_Remove_LinkInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const rte_remove_link = /** @type {((inputs?: Rte_Remove_LinkInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rte_Remove_LinkInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Link verwijderen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le lien")
	return /** @type {LocalizedString} */ ("Remove link")
});